export default __webpack_public_path__ + "images/slide_9.jpeg?05b64539e7ef59cd262126ba0fce11c7";